export default "__VITE_ASSET__DvJj24A6__"